<template>
  <v-container>
    <v-row class="mt-5" align="center" justify="center">
      <v-col lg="6" md="8" sm="10" xl="4" cols="12">
        <v-form ref="form" v-model="valid">
          <v-subheader class="pa-0">Derde partij</v-subheader>
          <v-card class="themed-color">
            <v-card-text>
              <v-text-field
                :counter="100"
                :rules="[(v) => !!v || 'Naam is verplicht', v => serverError('name'), (v) => !!v && v.length <= 100 || 'de naam mag maximaal 100 tekens bevatten']"
                label="Naam"
                required
                v-model="values.name"></v-text-field>
              <v-autocomplete
                item-value="id"
                item-text="name"
                v-model="values.organisations"
                :items="organisations"
                multiple
                label="Organisaties"
              ></v-autocomplete>

              <v-autocomplete
                item-value="id"
                item-text="name"
                v-model="values.manufacturers"
                :items="manufacturers"
                multiple
                label="Manufacturers"
              >

              </v-autocomplete>
            </v-card-text>
          </v-card>
          <v-subheader>Web</v-subheader>
          <v-card>
            <v-card-text>
              <v-text-field
                label="Webhook URL"
                :counter="191"
                :rules="[v => serverError('webhook_url')]"
                v-model="values.webhook_url"
              ></v-text-field>
            </v-card-text>
          </v-card>

          <v-btn v-if="values.id && !key" block color="primary" @click="fetchToken">
            Toon authenticatie sleutel
          </v-btn>

          <div v-if="key">
            <v-subheader>Authenticatie sleutel</v-subheader>
            <v-card>
              <v-card-text>
                <v-alert
                  :value="!!key"
                  color="primary"
                  style="word-break: break-all">
                  {{key}}
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click="key = !key">Sluit</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="refreshDialog = true">
                  Genereer nieuwe sleutel
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-form>
      </v-col>
    </v-row>

    <ThirdPartyKeyGenerator :show="refreshDialog"
                            :third-party-identifier="values.id"
                            @key="onKey"/>
  </v-container>
</template>

<script>
import Form from './../BaseForm';
import ThirdPartyKeyGenerator from './../ThirdParty/ThirdPartyKeyGenerator.vue';

export default {
  name: 'third-party-form',
  components: { ThirdPartyKeyGenerator },
  extends: Form,
  methods: {
    getOrganisations() {
      this.$http.get('organisation')
        .then((response) => {
          this.organisations = response.data.data;

          if (this.values.organisations) {
            this.values.organisations = this.values.organisations.map(entry => {
              return entry.id;
            });
          }
        });
    },
    getManufacturers() {
      this.$http.get('manufacturer')
        .then((response) => {
          this.manufacturers = response.data.data;

          if (this.values.manufacturers) {
            this.values.manufacturers = this.values.manufacturers.map(entry => {
              return entry.id;
            });
          }
        });
    },
    fetchToken() {
      this.$http.get('third-party/' + this.values.id + '/key')
        .then(response => this.key = response.data.key);
    },
    onKey(key) {
      this.key = key;
      this.refreshDialog = false;
    },
  },
  data: () => ({
    key: '',
    organisations: [],
    manufacturers: [],
    refreshDialog: false,
  }),
  created() {
    this.getOrganisations();
    this.getManufacturers();
    this.key = '';
  },
};
</script>
